import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'
import classnames from 'classnames'

import NumberInput from  './UI/NumberInput'
import Button from  './UI/Button'

import { capitalize } from '../utilities'
import velocityCurves from '../constants/velocityCurves.json'
import tooltips from '../constants/tooltips.json'

import {
  selectZone,
  setZoneSplitPoint,
  setZoneCurve,
  setZoneChannel
} from '../actions/'

const BarsSplitPointSettings = (props) => {
  const {
    selectedSplit,
    splits,
    onSelectSplit,
    onSetSplitPoint,
    onSetSplitCurve,
    onSetSplitChannel,
    showTooltips
  } = props

  const zones = ['A', 'B']
  const zonesSuffix = ['End', 'Begin']

  const curves = Object.keys(velocityCurves).map(key => ({value: velocityCurves[key], label: capitalize(key)}))

  return (
    <div className={classnames("bars-split-point-settings", `zone-${selectedSplit ? 'b' : 'a'}`)}>
      <h4
        className="zone-label"
        data-tip={tooltips['editor-zones']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >Zones</h4>
      <div
        className="zone-select button-group square"
        data-tip={tooltips['editor-zone-select']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        <Button name="A" kind="square" index={0} value={0} toggle={selectedSplit} onClick={ onSelectSplit } />
        <Button name="B" kind="square" index={1} value={1} toggle={selectedSplit} onClick={ onSelectSplit } />
      </div>
      <div
        className="zone-splits"
        data-tip={tooltips['editor-zone-split-point']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        <label className={classnames({'off': splits[selectedSplit].bar === -1 || splits[selectedSplit].bar === 43})}>
          {`Zone ${zones[selectedSplit]} ${zonesSuffix[selectedSplit]}`}
          <NumberInput
            min={selectedSplit ? 1: 0}
            max={selectedSplit ? 44 : 43}
            name={`Zone ${zones[selectedSplit]} ${zonesSuffix[selectedSplit]}`}
            value={splits[selectedSplit].bar + 1}
            onChange={(value) => {
              if(value > 44) return
                if(splits[1].bar > splits[0].bar){
                  if(selectedSplit === 1) {
                    onSetSplitPoint(1, value - 1)
                    setTimeout(() => onSetSplitPoint(0, value - 2), 10)
                  } else {
                    onSetSplitPoint(0, value - 1)
                    setTimeout(() => onSetSplitPoint(1, value), 10)
                  }
                }
              }
            }
          />
        </label>
      </div>
      <div
        className="zone-curve"
        data-tip={tooltips['editor-zone-curve']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        <label>
          Curve
          <Select
            name="split-curves"
            value={splits[selectedSplit].curve}
            options={curves}
            onChange={(value) => onSetSplitCurve(selectedSplit, value)}
          />
        </label>
      </div>
      <div
        className="zone-channels"
        data-tip={tooltips['editor-zone-channel']}
        data-multiline="true"
        data-place="bottom"
        data-tip-disable={!showTooltips}
        >
        <label>
          Channel
          <NumberInput
            min={1}
            max={16}
            name={`Zone ${zones[selectedSplit]} Channel`}
            value={splits[selectedSplit].channel + 1}
            onChange={(value) => onSetSplitChannel(selectedSplit, value)}
          />
        </label>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    selectedSplit: state.editor.selectedSplit,
    splits: state.currentPreset.splits,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectSplit: (target) => {
      dispatch(selectZone(~~target.value))
    },
    onSetSplitPoint: (zone, bar) => {
      dispatch(setZoneSplitPoint(zone, ~~bar))
    },
    onSetSplitCurve: (zone, curve) => {
      dispatch(setZoneCurve(zone, ~~curve))
    },
    onSetSplitChannel: (zone, channel) => {
      dispatch(setZoneChannel(zone, ~~channel - 1))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BarsSplitPointSettings)
